import { Trans } from "@helpers/translate";
import React, { FC, ReactNode } from "react";

export const Wrapper: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div
      className={`h-screen`}
      style={{
        minHeight: "500px",
      }}
    >
      <div className="h-screen bg-white text-black">{children}</div>
    </div>
  );
};

export const GlobalNotice = () => {
  return (
    <div className="bg-gray-100 text-center p-3 text-lg">
      <span>
        <b>
          <Trans id="global.notification.rebranding">TripleLights.com</Trans>
        </b>
        <Trans> has evolved into </Trans>
        <b>
          <Trans id="global.notification.rebranding">GoWithGuide.com</Trans>
        </b>
        <Trans> to better align with our global expansion.</Trans>
      </span>
      <a
        href="/triplelights"
        className="underline text-link hover:text-link-dark ml-2"
      >
        <Trans>Learn more</Trans>
      </a>
    </div>
  );
};
